<template>
  <div>
    <basic-container>
      <avue-crud
        :option="tableOption"
        :data="tableData"
        :table-loading="tableLoading"
        :page="page"
        ref="crud"
        @search-change="searchChange"
        @refresh-change="refreshChange(page)"
        @search-reset="searchClear"
        @row-save="handleSave"
        @row-update="handleUpdate"
        @selection-change="handleSelectionChange"
        @size-change="pageSizeChange"
        @current-change="pageChange"
      >
        <template slot="menuLeft">
          <el-button
            type="primary"
            size="small"
            plain
            @click.stop="handleAdd('form')"
          >新增分销产品</el-button>
        </template>
        <template
          slot-scope="scope"
          slot="menu"
        >
          <el-button
            type="primary"
            size="small"
            plain
            @click.stop="handleView(scope.row,scope.index)"
          >查看</el-button>
          <el-button
            type="primary"
            size="small"
            v-if="scope.row.status !='CANCEL'"
            plain
            @click.stop="handleEdit(scope.row,scope.index)"
          >修改</el-button>
          <el-button
            type="danger"
            size="small"
            v-if="scope.row.status !='CANCEL'"
            plain
            @click.stop="handleDel(scope.row,scope.index)"
          >取消分销</el-button>
        </template>

        <!-- <template slot="search">
        <el-form-item label="系统大类名称" size="small" style="margin-top: 4px">
          <el-col :md="32">
            <el-select
              v-model="currProduct"
              placeholder="请选择系统大类"
              required
              @change="choseClassifyItem"
              clearable
              value-key="id"
            >
              <el-option
                v-for="item in classifySelects"
                :key="item.id"
                :label="item.rootName"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-col>
        </el-form-item>
        </template>-->

      </avue-crud>
      <el-dialog
        :title="formVisibleTitle"
        :visible.sync="dialogFormVisible"
        width="50%"
      >
        <el-form
          :model="form"
          :rules="rules"
          ref="form"
          style="margin-left:50px"
        >
          <el-form-item
            label="选择产品："
            prop="currProduct"
            :label-width="formLabelWidth"
            style="width:50%"
          >
            <i style="color:red;position: absolute;left: -92px;">*</i>
            <div>
              <el-select
                v-model="form.currProduct"
                clearable
                :disabled="isEdit"
                @change="chooseProducts"
                placeholder="请选择产品"
                filterable
                value-key="id"
              >
                <el-option
                  v-for="item in products"
                  :key="item.id"
                  :label="item.name"
                  :value="item"
                >
                </el-option>
              </el-select>
            </div>
          </el-form-item>
          <el-form-item
            label="产品状态："
            :label-width="formLabelWidth"
            style="width:50%"
          >
            <!-- <el-input v-model="form.name" disabled>{{form.name}}</el-input> -->
            <span>{{form.currProduct.productStatus?(form.currProduct.productStatus==='SELL'?'售卖中':form.currProduct.productStatus==='SECKILL'?'秒杀中':form.currProduct.productStatus==='GROUP_BUY'?'团购中':'未售卖'):'无'}}</span>
          </el-form-item>
          <el-form-item
            label="产品价格："
            :label-width="formLabelWidth"
            style="width:50%"
          >
            <!-- <el-input v-model="form.name" disabled>{{form.name}}</el-input> -->
            <span>{{form.currProduct.productStatus ==='SELL'?form.currProduct.price:form.currProduct.activityPrice}} 元</span>
          </el-form-item>
          <el-form-item
            label="佣金结算方式："
            prop="clearingType"
            :label-width="formLabelWidth"
            style="width:50%"
          >
            <div style="display:flex;">
              <el-tooltip
                class="item"
                effect="dark"
                placement="top-start"
              >
                <div slot="content">有两种，自动结算和手动结算.自动结算即消费者下单支付后,
                  佣<br />金自动结算到推广员账户.手动结算，
                  则目前输入的只是估计值,<br />以后期代理商支付佣金时为准.</div>
                <i
                  class="el-icon-warning"
                  style="position: absolute;left: -23px;"
                ></i>
              </el-tooltip>
              <el-select
                v-model="form.clearingType"
                placeholder="请选择佣金结算方式"
              >
                <el-option
                  label="手动结算"
                  value="HAND"
                ></el-option>
                <el-option
                  label="自动结算"
                  value="AUTO"
                ></el-option>
              </el-select>
            </div>
          </el-form-item>
          <el-form-item
            label="推广人抽成类型："
            :label-width="formLabelWidth"
            prop="royaltyType"
            style="width:50%"
          >
            <el-select
              v-model="form.royaltyType"
              placeholder="请选择推广人抽成类型"
              @change="changeRoyaltyType(form.royaltyType)"
            >
              <el-option
                label="定额"
                value="MONEY"
              ></el-option>
              <el-option
                label="百分比"
                value="PERCENT"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item
            label="分销渠道："
            prop="checkList"
            :label-width="formLabelWidth"
            style="width:80%"
          >
            <el-checkbox-group v-model="form.checkList">
              <el-checkbox
                label="慧家掌上通小程序"
                @change="changeCheckList('ZST')"
              ></el-checkbox>
              <el-checkbox
                label="慧家工程师APP"
                @change="changeCheckList('GCS')"
              ></el-checkbox>
              <el-checkbox
                label="慧家商户APP"
                @change="changeCheckList('SH')"
              ></el-checkbox>
            </el-checkbox-group>
          </el-form-item>
          <div v-if="isZST">
            <span style="color:red;">慧家掌上通小程序</span>
            <el-form-item
              label="推广人佣金/比例："
              prop="miniRate"
              :label-width="formLabelWidth"
              style="width:50%"
            >
              <el-input v-model="form.miniRate"></el-input>
              <span
                style="color:#777;"
                v-if="form.clearingType ==='HAND'"
              >若手动结算，则填写大概的佣金或比例即可</span>
            </el-form-item>
            <el-form-item
              :label-width="formLabelWidth"
              style="width:80%"
            >
              <div>
                <el-table
                  :data="zstPlans"
                  border
                >
                  <el-table-column
                    prop="labelId"
                    align="center"
                    label="推广人标签选择"
                  >
                    <template slot-scope="scope">
                      <el-select
                        v-model="scope.row.labelId"
                        placeholder="全部"
                        @change="changeTagsPeople(currClassify)"
                      >
                        <el-option
                          v-for="item in zstClassifySelects"
                          :key="item.id"
                          :label="item.name"
                          :value="item.id"
                        ></el-option>
                      </el-select>
                    </template>
                  </el-table-column>
                  <el-table-column
                    prop="commissionRate"
                    align="center"
                    label="佣金/比例"
                  >
                    <template slot-scope="scope">
                      <el-input
                        name="commissionRate"
                        v-model="scope.row.commissionRate"
                        :value="scope.row.commissionRate"
                      ></el-input>
                    </template>
                  </el-table-column>
                  <el-table-column
                    prop="commission"
                    align="center"
                    v-if="form.royaltyType==='MONEY'"
                    label="佣金"
                  >
                    <template slot-scope="scope">
                      <!-- <el-input
                        type="input"
                        disabled
                        name="commission"
                        v-model="scope.row.commission"
                        :value="scope.row.commission"
                      ></el-input> -->
                      <span>{{scope.row.commissionRate}}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    prop="commission"
                    align="center"
                    v-if="form.royaltyType==='PERCENT'"
                    label="佣金"
                  >
                    <template slot-scope="scope">
                      <div v-if='form.currProduct.productStatus=="SELL"'>
                        <span>{{(form.currProduct.price.split('-')[0]/100*scope.row.commissionRate).toFixed(2)}}元</span>
                        <span>{{form.currProduct.price.split('-')[1]?(('-'+(form.currProduct.price.split('-')[1]/100*scope.row.commissionRate).toFixed(2))+'元'):null}}</span>
                      </div>
                      <div v-if='form.currProduct.productStatus!=="SELL"'>
                        <span>{{(form.currProduct.activityPrice.split('-')[0]/100*scope.row.commissionRate).toFixed(2)}}元</span>
                        <span>{{form.currProduct.activityPrice.split('-')[1]?(('-'+(form.currProduct.activityPrice.split('-')[1]/100*scope.row.commissionRate).toFixed(2))+'元'):null}}</span>
                      </div>

                    </template>
                    <!-- <template slot-scope="scope">
                      <el-input
                        type="input"
                        disabled
                        name="content"
                        v-model="scope.row.content"
                        :value="scope.row.content"
                      >{{1}}</el-input>
                    </template> -->
                  </el-table-column>
                  <el-table-column
                    align="center"
                    label="操作"
                  >
                    <template slot-scope="scope">
                      <el-button
                        type="warning"
                        icon="el-icon-check"
                        size="small"
                        @click="handleGatherPlansDelete(scope.$index, scope.row,'zst')"
                      >删除</el-button>
                    </template>
                  </el-table-column>
                </el-table>
                <div style="margin-top: 20px">
                  <el-button @click="handleGatherPlansAddRows('zst')">添加额外分成规则</el-button>
                </div>
              </div>
            </el-form-item>
          </div>
          <div v-if="isGCS">
            <span style="color:red;">慧家掌工程师APP</span>
            <el-form-item
              label="推广人佣金/比例："
              prop="engineerRate"
              :label-width="formLabelWidth"
              style="width:50%"
            >
              <el-input v-model="form.engineerRate"></el-input>
              <span
                style="color:#777;"
                v-if="form.clearingType ==='HAND'"
              >若手动结算，则填写大概的佣金或比例即可</span>
            </el-form-item>
            <el-form-item
              :label-width="formLabelWidth"
              style="width:80%"
            >
              <div>
                <el-table
                  :data="gcsPlans"
                  border
                >
                  <el-table-column
                    prop="labelId"
                    align="center"
                    label="推广人标签选择"
                  >
                    <template slot-scope="scope">
                      <el-select
                        v-model="scope.row.labelId"
                        placeholder="全部"
                      >
                        <el-option
                          v-for="item in engineerClassifySelects"
                          :key="item.id"
                          :label="item.name"
                          :value="item.id"
                        ></el-option>
                      </el-select>
                    </template>
                  </el-table-column>
                  <el-table-column
                    prop="commissionRate"
                    align="center"
                    label="佣金/比例"
                  >
                    <template slot-scope="scope">
                      <el-input
                        type="input"
                        name="commissionRate"
                        v-model="scope.row.commissionRate"
                        :value="scope.row.commissionRate"
                      ></el-input>
                    </template>
                  </el-table-column>
                  <el-table-column
                    prop="commission"
                    align="center"
                    v-if="form.royaltyType==='MONEY'"
                    label="佣金"
                  >
                    <template slot-scope="scope">
                      <!-- <el-input
                        type="input"
                        disabled
                        name="commission"
                        v-model="scope.row.commission"
                        :value="scope.row.commission"
                      ></el-input> -->
                      <span>{{scope.row.commissionRate}}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    prop="commission"
                    align="center"
                    v-if="form.royaltyType==='PERCENT'"
                    label="佣金"
                  >
                    <template slot-scope="scope">
                      <div v-if='form.currProduct.productStatus=="SELL"'>
                        <span>{{(form.currProduct.price.split('-')[0]/100*scope.row.commissionRate).toFixed(2)}}元</span>
                        <span>{{form.currProduct.price.split('-')[1]?(('-'+(form.currProduct.price.split('-')[1]/100*scope.row.commissionRate).toFixed(2))+'元'):null}}</span>
                      </div>
                      <div v-if='form.currProduct.productStatus!=="SELL"'>
                        <span>{{(form.currProduct.activityPrice.split('-')[0]/100*scope.row.commissionRate).toFixed(2)}}元</span>
                        <span>{{form.currProduct.activityPrice.split('-')[1]?(('-'+(form.currProduct.activityPrice.split('-')[1]/100*scope.row.commissionRate).toFixed(2))+'元'):null}}</span>
                      </div>

                    </template>
                    <!-- <template slot-scope="scope">
                      <el-input
                        type="input"
                        disabled
                        name="content"
                        v-model="scope.row.content"
                        :value="scope.row.content"
                      >{{1}}</el-input>
                    </template> -->
                  </el-table-column>
                  <el-table-column
                    align="center"
                    label="操作"
                  >
                    <template slot-scope="scope">
                      <el-button
                        type="warning"
                        icon="el-icon-check"
                        size="small"
                        @click="handleGatherPlansDelete(scope.$index, scope.row,'gcs')"
                      >删除</el-button>
                    </template>
                  </el-table-column>
                </el-table>
                <div style="margin-top: 20px">
                  <el-button @click="handleGatherPlansAddRows('gcs')">添加额外分成规则</el-button>
                </div>
              </div>
            </el-form-item>
          </div>
          <div v-if="isSH">
            <span style="color:red;">慧家商户APP</span>
            <el-form-item
              label="推广人佣金/比例："
              prop="merchantRate"
              :label-width="formLabelWidth"
              style="width:50%"
            >
              <el-input v-model="form.merchantRate"></el-input>
              <span
                style="color:#777;"
                v-if="form.clearingType ==='HAND'"
              >若手动结算，则填写大概的佣金或比例即可</span>
            </el-form-item>
            <el-form-item
              :label-width="formLabelWidth"
              style="width:80%"
            >
              <div>
                <el-table
                  :data="shPlans"
                  border
                >
                  <el-table-column
                    prop="labelId"
                    align="center"
                    label="推广人标签选择"
                  >
                    <template slot-scope="scope">
                      <el-select
                        v-model="scope.row.labelId"
                        placeholder="全部"
                      >
                        <el-option
                          v-for="item in merchantClassifySelects"
                          :key="item.id"
                          :label="item.name"
                          :value="item.id"
                        ></el-option>
                      </el-select>
                    </template>
                  </el-table-column>
                  <el-table-column
                    prop="commissionRate"
                    align="center"
                    label="佣金/比例"
                  >
                    <template slot-scope="scope">
                      <el-input
                        type="input"
                        name="commissionRate"
                        v-model="scope.row.commissionRate"
                        :value="scope.row.commissionRate"
                      ></el-input>
                    </template>
                  </el-table-column>
                  <el-table-column
                    prop="commission"
                    align="center"
                    v-if="form.royaltyType==='MONEY'"
                    label="佣金"
                  >
                    <template slot-scope="scope">
                      <!-- <el-input
                        type="input"
                        disabled
                        name="commission"
                        v-model="scope.row.commission"
                        :value="scope.row.commission"
                      ></el-input> -->
                      <span>{{scope.row.commissionRate}}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    prop="commission"
                    align="center"
                    v-if="form.royaltyType==='PERCENT'"
                    label="佣金"
                  >
                    <template slot-scope="scope">
                      <div v-if='form.currProduct.productStatus=="SELL"'>
                        <span>{{(form.currProduct.price.split('-')[0]/100*scope.row.commissionRate).toFixed(2)}}元</span>
                        <span>{{form.currProduct.price.split('-')[1]?(('-'+(form.currProduct.price.split('-')[1]/100*scope.row.commissionRate).toFixed(2))+'元'):null}}</span>
                      </div>
                      <div v-if='form.currProduct.productStatus!=="SELL"'>
                        <span>{{(form.currProduct.activityPrice.split('-')[0]/100*scope.row.commissionRate).toFixed(2)}}元</span>
                        <span>{{form.currProduct.activityPrice.split('-')[1]?(('-'+(form.currProduct.activityPrice.split('-')[1]/100*scope.row.commissionRate).toFixed(2))+'元'):null}}</span>
                      </div>
                    </template>
                    <!-- <template slot-scope="scope">
                      <el-input
                        type="input"
                        disabled
                        name="content"
                        v-model="scope.row.content"
                        :value="scope.row.content"
                      >{{1}}</el-input>
                    </template> -->
                  </el-table-column>
                  <el-table-column
                    align="center"
                    label="操作"
                  >
                    <template slot-scope="scope">
                      <el-button
                        type="warning"
                        icon="el-icon-check"
                        size="small"
                        @click="handleGatherPlansDelete(scope.$index, scope.row,'sh')"
                      >删除</el-button>
                    </template>
                  </el-table-column>
                </el-table>
                <div style="margin-top: 20px">
                  <el-button @click="handleGatherPlansAddRows('sh')">添加额外分成规则</el-button>
                </div>
              </div>
            </el-form-item>
          </div>

        </el-form>
        <div
          slot="footer"
          class="dialog-footer"
        >
          <el-button
            type="primary"
            v-if="submitBtn==='发 布'"
            @click="releaseHandle('form')"
          >{{submitBtn}}</el-button>
          <el-button
            type="primary"
            v-else-if="submitBtn==='修 改'"
            @click="handleUpdate('form')"
          >{{submitBtn}}</el-button>
          <el-button @click="dialogFormVisible = false">取 消</el-button>
        </div>
      </el-dialog>
    </basic-container>
  </div>
</template>

<script>
import { releaseSaleOption } from "@/const/salesCloud/releaseSaleOption";
import {
  releaseSaleList,
  findProducts,
  addSales,
  findLabelList,
  editReleaseSale,
  findPlaceDetail,
  cancelPlaceSale
} from "@/api/salesCloud/releaseSale";

export default {
  name: "releaseSale",
  data() {
    return {
      tableOption: releaseSaleOption, //表格设置属性
      tableData: [], //表格的数据
      tablePage: 1,
      form: { checkList: [], currProduct: { name: "", id: "" } },
      formLabelWidth: "150px",
      dialogFormVisible: false,
      tableLoading: false,
      shPlans: [],
      gcsPlans: [],
      zstPlans: [],
      formVisibleTitle: "新增分销产品",
      submitBtn: "发 布",
      currClassify: "",
      isZST: false,
      isGCS: false,
      isSH: false,
      isEdit: false,
      products: [],
      engineerClassifySelects: [],
      zstClassifySelects: [],
      merchantClassifySelects: [],
      tabelObj: {},
      page: {
        total: 0, //总页数
        currentPage: 1, //当前页数
        pageSize: 10 //每页显示多少条
      },
      grade: {
        box: false,
        check: []
      },
      rules: {
        checkList: [
          {
            required: true,
            message: "请至少选择一个分销渠道",
            trigger: "change"
          }
        ],
        // currProduct: [
        //   { required: true, message: "请选择产品", trigger: "change" }
        // ],
        royaltyType: [
          { required: true, message: "请选择推广人抽成类型", trigger: "change" }
        ],
        clearingType: [
          { required: true, message: "请选择佣金结算方式", trigger: "change" }
        ],
        miniRate: [
          { required: true, message: "请输入推广人佣金/比例", trigger: "blur" }
        ],
        merchantRate: [
          { required: true, message: "请输入推广人佣金/比例", trigger: "blur" }
        ],
        engineerRate: [
          { required: true, message: "请输入推广人佣金/比例", trigger: "blur" }
        ]
      }
    };
  },
  created() {
    this.handleList();
    findProducts().then(res => {
      console.log(res);
      let data = JSON.parse(res.data);
      console.log(data);
      //如果未售卖则不加入列表
      for (let i = 0; i < data.length; i++) {
        if (data[i].productStatus != "NOT_SELL") {
          this.products.push(data[i]);
        }
      }
    });
  },
  watch: {},
  mounted() {},
  computed: {},
  props: [],
  methods: {
    changeRoyaltyType(type) {
      console.log(type);
      this.form.royaltyType = type;
    },
    clean() {
      this.isZST = false;
      this.isGCS = false;
      this.isSH = false;
      this.isEdit = false;
      this.form = {
        checkList: [],
        royaltyType: "",
        clearingType: "",
        currProduct: { name: "", id: "" }
      };
      this.gcsPlans = [];
      this.shPlans = [];
      this.zstPlans = [];
    },
    changeTagsPeople(currClassify) {
      // let checkData = this.classifySelects;
      // let ids = [];
      // checkData.map((item, index) => {
      //   for (let i = 0; i < checkData.length + 1; i++) {
      //     if (currClassify[i] == item.id) {
      //       ids.push(...item.refIds);
      //     }
      //   }
      // });
      // let newIds = Array.from(new Set(ids));
      // this.totalPeople = newIds.length;
    },
    chooseProducts() {
      console.log(this.form.currProduct);
    },
    changeCheckList(label) {
      console.log(label);
      if (label === "ZST") {
        let params = { clientType: "JOINS_PROMOTION_SPECIALIST" };
        findLabelList(params).then(res => {
          console.log(res);
          let data = JSON.parse(res.data);
          console.log(data);
          // this.totalPeople = data.all;
          data = data.list.map(item => {
            item.name = item.name + "(" + item.count + ")";
            return item;
          });
          this.zstClassifySelects = data;
        });
        this.isZST = !this.isZST;
      } else if (label === "SH") {
        let params = { clientType: "JOINS_MERCHANT" };
        findLabelList(params).then(res => {
          console.log(res);
          let data = JSON.parse(res.data);
          console.log(data);
          // this.totalPeople = data.all;
          data = data.list.map(item => {
            item.name = item.name + "(" + item.count + ")";
            return item;
          });
          this.merchantClassifySelects = data;
        });
        this.isSH = !this.isSH;
      } else {
        let params = { clientType: "JOINS_ENGINEER" };
        findLabelList(params).then(res => {
          console.log(res);
          let data = JSON.parse(res.data);
          console.log(data);
          // this.totalPeople = data.all;
          data = data.list.map(item => {
            item.name = item.name + "(" + item.count + ")";
            return item;
          });
          this.engineerClassifySelects = data;
        });
        this.isGCS = !this.isGCS;
      }
    },
    handleGatherPlansAddRows(option) {
      if (option === "zst") {
        let list = {
          labelId: "",
          commissionRate: "",
          commission: ""
        };
        this.zstPlans.unshift(list);
      }
      if (option === "gcs") {
        let list = {
          labelId: "",
          commissionRate: "",
          commission: ""
        };
        this.gcsPlans.unshift(list);
      }
      if (option === "sh") {
        let list = {
          labelId: "",
          commissionRate: "",
          commission: ""
        };
        this.shPlans.unshift(list);
      }
    },
    handleGatherPlansDelete(index, row, option) {
      if (option === "zst") {
        this.zstPlans.splice(index, 1);
      }
      if (option === "gcs") {
        this.gcsPlans.splice(index, 1);
      }
      if (option === "sh") {
        this.shPlans.splice(index, 1);
      }
      // this.gatherPlans.splice(index, 1);
    },

    searchClear() {},
    pageSizeChange(pageSize) {
      this.tableLoading = true;
      let params = this.$refs.crud.searchForm;
      console.log(this.page);
      params.page = this.page.currentPage;
      params.size = pageSize;
      this.downloadData = params;
      releaseSaleList(params).then(res => {
        let data = JSON.parse(res.data);
        this.tableData = data.rows;
        this.page = {
          total: data.total,
          currentPage: this.page.currentPage,
          pageSize: pageSize
        };
        console.log(this.page);
        this.tableLoading = false;
      });
    },
    pageChange(page) {
      this.tableLoading = true;
      let params = this.$refs.crud.searchForm;
      params.page = page;
      params.size = this.page.pageSize;
      this.downloadData = params;
      releaseSaleList(params).then(res => {
        let data = JSON.parse(res.data);
        this.tableData = data.rows;
        this.page = {
          total: data.total,
          currentPage: page,
          pageSize: this.page.pageSize
        };
        this.tableLoading = false;
      });
    },
    searchChange(params) {
      this.tableLoading = true;
      // let params = this.$refs.crud.searchForm
      params.page = this.page.currentPage;
      params.size = this.page.pageSize;
      // if (
      //   null != params.startDate_endDate &&
      //   undefined != params.startDate_endDate &&
      //   "" != params.startDate_endDate
      // ) {
      //   params.createTimeStart = params.startDate_endDate[0];
      //   params.createTimeEnd = params.startDate_endDate[1];
      // } else {
      //   delete params.createTimeStart;
      //   delete params.createTimeEnd;
      // }
      releaseSaleList(params).then(res => {
        let data = JSON.parse(res.data);
        this.tableData = data.rows;
        this.page = {
          total: data.total,
          currentPage: params.page,
          pageSize: params.size
        };
        this.tableLoading = false;
      });
    },
    //eslint-disable-next-line
    refreshChange(page) {
      this.tableLoading = true;
      let params = this.$refs.crud.searchForm;
      params.page = page.currentPage;
      params.size = page.pageSize;
      this.downloadData = params;
      console.log(page);
      releaseSaleList(params).then(res => {
        let data = JSON.parse(res.data);
        this.tableData = data.rows;
        this.page = {
          total: data.total,
          currentPage: page.currentPage,
          pageSize: page.pageSize
        };
        this.tableLoading = false;
      });
    },
    /**
     * @title 打开新增窗口
     * @detail 调用crud的handleadd方法即可
     *
     **/
    handleAdd(formName) {
      console.log(this);
      this.clean();
      //标题提交按钮修改

      this.formVisibleTitle = "新增分销产品";
      this.submitBtn = "发 布";
      this.dialogFormVisible = true;
      if (this.$refs[formName] != undefined) {
        this.$refs[formName].resetFields();
      }
      // this.$refs.crud.rowAdd();
    },
    releaseHandle(formName) {
      let params = {};
      params.productId = this.form.currProduct.id;
      params.price = this.form.currProduct.price;
      params.activityPrice = this.form.currProduct.activityPrice;
      params.clearingType = this.form.clearingType;
      params.royaltyType = this.form.royaltyType;
      params.type = this.form.currProduct.productStatus;
      params.placeRuleList = [];
      if (this.isZST) {
        let zstobj = {};
        zstobj.clientType = "JOINS_PROMOTION_SPECIALIST";
        zstobj.miniRate = this.form.miniRate;
        zstobj.labelList = [];
        if (zstobj.miniRate < 0) {
          this.$message({
            showClose: true,
            message: "金额填写有误",
            type: "error"
          });
          this.dialogFormVisible = false;
          return;
        }
        for (let i = 0; i < this.zstPlans.length; i++) {
          if (this.zstPlans[i].commissionRate < 0) {
            this.$message({
              showClose: true,
              message: "金额填写有误",
              type: "error"
            });
            this.dialogFormVisible = false;
            return;
          }
        }
        console.log(this.zstPlans);
        zstobj.labelList.push(...this.zstPlans);
        params.placeRuleList.push(zstobj);
      }
      if (this.isGCS) {
        let gcsobj = {};
        gcsobj.clientType = "JOINS_ENGINEER";
        gcsobj.engineerRate = this.form.engineerRate;
        gcsobj.labelList = [];
        if (gcsobj.engineerRate < 0) {
          this.$message({
            showClose: true,
            message: "金额填写有误",
            type: "error"
          });
          this.dialogFormVisible = false;
          return;
        }
        for (let i = 0; i < this.gcsPlans.length; i++) {
          if (this.gcsPlans[i].commissionRate < 0) {
            this.$message({
              showClose: true,
              message: "金额填写有误",
              type: "error"
            });
            this.dialogFormVisible = false;
            return;
          }
        }
        gcsobj.labelList.push(...this.gcsPlans);
        params.placeRuleList.push(gcsobj);
        console.log(gcsobj);
      }
      if (this.isSH) {
        let shobj = {};
        shobj.clientType = "JOINS_MERCHANT";
        shobj.merchantRate = this.form.merchantRate;
        shobj.labelList = [];
        if (shobj.merchantRate < 0) {
          this.$message({
            showClose: true,
            message: "金额填写有误",
            type: "error"
          });
          this.dialogFormVisible = false;
          return;
        }
        for (let i = 0; i < this.shPlans.length; i++) {
          if (this.shPlans[i].commissionRate < 0) {
            this.$message({
              showClose: true,
              message: "金额填写有误",
              type: "error"
            });
            this.dialogFormVisible = false;
            return;
          }
        }
        shobj.labelList.push(...this.shPlans);
        params.placeRuleList.push(shobj);
        console.log(shobj);
      }
      console.log(this.form);
      console.log(this.zstPlans);
      console.log(this.gcsPlans);
      console.log(this.shPlans);
      console.log(params);
      console.log(this);
      this.$refs[formName].validate(valid => {
        if (valid) {
          console.log("success submit!!");
          addSales(params).then(res => {
            if (res.code == "200") {
              this.$message({
                showClose: true,
                message: "新增成功",
                type: "success"
              });
              this.dialogFormVisible = false;
              this.handleList();
            } else {
              this.$message({
                showClose: true,
                message: res.message,
                type: "error"
              });
              this.dialogFormVisible = false;
            }
          });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    handleEdit(row, index) {
      this.clean();
      console.log(row);
      this.isEdit = true;
      //标题提交按钮修改
      this.rowId = row.id;
      this.formVisibleTitle = "修改";
      this.submitBtn = "修 改";
      this.form.currProduct.name = row.name;
      // this.form.royaltyType = "MONEY";
      findPlaceDetail(row.id).then(res => {
        let data = JSON.parse(res.data);
        console.log(data);
        // data.placeRuleResponses
        //选择产品回显
        this.form.currProduct = {};
        this.form.currProduct.id = data.productId;
        //产品状态回显
        this.form.currProduct.productStatus = data.productStatus;
        console.log(this.form);
        //产品价格回显
        this.form.currProduct.price = data.price;
        this.form.currProduct.activityPrice = data.activityPrice;
        //佣金结算方式回显
        this.form.clearingType = data.clearingType;
        // this.form.clearingType = "HAND";

        //推广人抽成类型回显
        this.form.royaltyType = data.royaltyType;
        for (let i = 0; i < data.placeRuleResponses.length; i++) {
          console.log(data.placeRuleResponses[i]);
          //慧家掌上通小程序回显
          if (
            data.placeRuleResponses[i].clientType ===
            "JOINS_PROMOTION_SPECIALIST"
          ) {
            //分销渠道回显
            this.isZST = true;
            this.form.checkList.push("慧家掌上通小程序");
            //推广人佣金/比例回显
            this.form.miniRate = data.placeRuleResponses[i].miniRate;
            //sku回显
            let params = { clientType: "JOINS_PROMOTION_SPECIALIST" };
            findLabelList(params).then(res => {
              console.log(res);
              let data = JSON.parse(res.data);
              console.log(data);
              // this.totalPeople = data.all;
              data = data.list.map(item => {
                item.name = item.name + "(" + item.count + ")";
                return item;
              });
              this.zstClassifySelects = data;
            });
            this.zstPlans = data.placeRuleResponses[i].labelList;
          }
          if (data.placeRuleResponses[i].clientType === "JOINS_MERCHANT") {
            //分销渠道回显
            this.isSH = true;
            this.form.checkList.push("慧家商户APP");
            //推广人佣金/比例回显
            this.form.merchantRate = data.placeRuleResponses[i].merchantRate;
            //sku回显
            let params = { clientType: "JOINS_MERCHANT" };
            findLabelList(params).then(res => {
              console.log(res);
              let data = JSON.parse(res.data);
              console.log(data);
              // this.totalPeople = data.all;
              data = data.list.map(item => {
                item.name = item.name + "(" + item.count + ")";
                return item;
              });
              this.merchantClassifySelects = data;
            });
            this.shPlans = data.placeRuleResponses[i].labelList;
          }
          if (data.placeRuleResponses[i].clientType === "JOINS_ENGINEER") {
            //分销渠道回显
            this.isGCS = true;
            this.form.checkList.push("慧家工程师APP");
            //推广人佣金/比例回显
            this.form.engineerRate = data.placeRuleResponses[i].engineerRate;
            //sku回显
            let params = { clientType: "JOINS_ENGINEER" };
            findLabelList(params).then(res => {
              console.log(res);
              let data = JSON.parse(res.data);
              console.log(data);
              // this.totalPeople = data.all;
              data = data.list.map(item => {
                item.name = item.name + "(" + item.count + ")";
                return item;
              });
              this.engineerClassifySelects = data;
            });
            this.gcsPlans = data.placeRuleResponses[i].labelList;
          }
        }

        this.dialogFormVisible = true;
      });
      // this.$refs.crud.rowAdd();
    },
    handleView(row, index) {
      this.clean();
      console.log(row);
      //标题提交按钮修改
      this.rowId = row.id;
      this.formVisibleTitle = "查看";
      this.submitBtn = "查 看";
      this.form.currProduct.name = row.name;
      findPlaceDetail(row.id).then(res => {
        let data = JSON.parse(res.data);
        console.log(data);
        // data.placeRuleResponses
        //选择产品回显
        this.form.currProduct = {};
        this.form.currProduct.id = data.productId;
        //产品状态回显
        this.form.currProduct.productStatus = data.productStatus;
        console.log(this.form);
        //产品价格回显
        this.form.currProduct.price = data.price;
        this.form.currProduct.activityPrice = data.activityPrice;
        //佣金结算方式回显
        this.form.clearingType = data.clearingType;
        // this.form.clearingType = "HAND";

        //推广人抽成类型回显
        this.form.royaltyType = data.royaltyType;
        for (let i = 0; i < data.placeRuleResponses.length; i++) {
          console.log(data.placeRuleResponses[i]);
          //慧家掌上通小程序回显
          if (
            data.placeRuleResponses[i].clientType ===
            "JOINS_PROMOTION_SPECIALIST"
          ) {
            //分销渠道回显
            this.isZST = true;
            this.form.checkList.push("慧家掌上通小程序");
            //推广人佣金/比例回显
            this.form.miniRate = data.placeRuleResponses[i].miniRate;
            //sku回显
            let params = { clientType: "JOINS_PROMOTION_SPECIALIST" };
            findLabelList(params).then(res => {
              console.log(res);
              let data = JSON.parse(res.data);
              console.log(data);
              // this.totalPeople = data.all;
              data = data.list.map(item => {
                item.name = item.name + "(" + item.count + ")";
                return item;
              });
              this.zstClassifySelects = data;
            });
            this.zstPlans = data.placeRuleResponses[i].labelList;
          }
          if (data.placeRuleResponses[i].clientType === "JOINS_MERCHANT") {
            //分销渠道回显
            this.isSH = true;
            this.form.checkList.push("慧家商户APP");
            //推广人佣金/比例回显
            this.form.merchantRate = data.placeRuleResponses[i].merchantRate;
            //sku回显
            let params = { clientType: "JOINS_MERCHANT" };
            findLabelList(params).then(res => {
              console.log(res);
              let data = JSON.parse(res.data);
              console.log(data);
              // this.totalPeople = data.all;
              data = data.list.map(item => {
                item.name = item.name + "(" + item.count + ")";
                return item;
              });
              this.merchantClassifySelects = data;
            });
            this.shPlans = data.placeRuleResponses[i].labelList;
          }
          if (data.placeRuleResponses[i].clientType === "JOINS_ENGINEER") {
            //分销渠道回显
            this.isGCS = true;
            this.form.checkList.push("慧家工程师APP");
            //推广人佣金/比例回显
            this.form.engineerRate = data.placeRuleResponses[i].engineerRate;
            //sku回显
            let params = { clientType: "JOINS_ENGINEER" };
            findLabelList(params).then(res => {
              console.log(res);
              let data = JSON.parse(res.data);
              console.log(data);
              // this.totalPeople = data.all;
              data = data.list.map(item => {
                item.name = item.name + "(" + item.count + ")";
                return item;
              });
              this.engineerClassifySelects = data;
            });
            this.gcsPlans = data.placeRuleResponses[i].labelList;
          }
        }

        this.dialogFormVisible = true;
      });
      // this.$refs.crud.rowAdd();
    },

    /**
     * @title 获取数据
     * @detail 赋值为tableData表格即可
     *
     **/
    handleList() {
      this.tableLoading = true;
      let params = {
        page: this.page.currentPage,
        size: this.page.pageSize
      };
      this.downloadData = params;
      releaseSaleList(params).then(res => {
        let data = JSON.parse(res.data);
        this.tableData = data.rows;
        this.page = {
          total: data.total,
          currentPage: this.page.currentPage,
          pageSize: this.page.pageSize
        };
        console.log(this.page);
        this.tableLoading = false;
      });
    },
    /**
     * @title 数据添加
     * @param row 为当前的数据
     * @param done 为表单关闭函数
     *
     **/
    handleSave(row, done) {
      row.rootId = this.currProduct;
      // row.price = this.currProduct.price
      // row.activityPrice = this.currProduct.activityPrice
      console.log(row);
      addSales(row).then(res => {
        if (res.code == "200") {
          this.$message({
            showClose: true,
            message: "新增成功",
            type: "success"
          });
          done();
          this.handleList();
        } else {
          this.$message({
            showClose: true,
            message: res.message,
            type: "error"
          });
          done();
        }
      });
    },
    /**
     * @title 当前选中的数据
     * @param val 选中的值
     *
     **/
    handleSelectionChange() {
      // console.log(val);
      // this.tableRow = val;
      // this.$notify({
      //     showClose: true,
      //     message: JSON.stringify(val),
      //     type: 'success',
      // });
    },
    /**
     * @title 数据删除
     * @param row 为当前的数据
     * @param index 为当前更新数据的行数
     *
     **/
    handleDel(row) {
      this.$confirm(`是否确认取消分销?`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          cancelPlaceSale(row.id).then(res => {
            if (res.code == "200") {
              this.$message({
                showClose: true,
                message: "取消分销成功",
                type: "success"
              });
              this.handleList();
            } else {
              this.$message({
                showClose: true,
                message: res.message,
                type: "error"
              });
            }
          });
        })
        .catch(() => {});
    },
    /**
     * @title 数据更新
     * @param row 为当前的数据
     * @param index 为当前更新数据的行数
     * @param done 为表单关闭函数
     *
     **/
    handleUpdate(formName) {
      let params = {};
      params.id = this.rowId;
      params.productId = this.form.currProduct.id;
      params.price = this.form.currProduct.price;
      params.activityPrice = this.form.currProduct.activityPrice;
      params.clearingType = this.form.clearingType;
      params.royaltyType = this.form.royaltyType;
      params.type = this.form.currProductproductStatus;
      params.placeRuleResponses = [];
      if (this.isZST) {
        let zstobj = {};
        zstobj.clientType = "JOINS_PROMOTION_SPECIALIST";
        zstobj.miniRate = this.form.miniRate;
        zstobj.labelList = [];
        if (zstobj.miniRate < 0) {
          this.$message({
            showClose: true,
            message: "金额填写有误",
            type: "error"
          });
          this.dialogFormVisible = false;
          return;
        }
        for (let i = 0; i < this.zstPlans.length; i++) {
          if (this.zstPlans[i].commissionRate < 0) {
            this.$message({
              showClose: true,
              message: "金额填写有误",
              type: "error"
            });
            this.dialogFormVisible = false;
            return;
          }
        }
        zstobj.labelList.push(...this.zstPlans);
        params.placeRuleResponses.push(zstobj);
        console.log(zstobj);
      }
      if (this.isGCS) {
        let gcsobj = {};
        gcsobj.clientType = "JOINS_ENGINEER";
        gcsobj.engineerRate = this.form.engineerRate;
        gcsobj.labelList = [];
        if (gcsobj.miniRate < 0) {
          this.$message({
            showClose: true,
            message: "金额填写有误",
            type: "error"
          });
          this.dialogFormVisible = false;
          return;
        }
        for (let i = 0; i < this.gcsPlans.length; i++) {
          if (this.gcsPlans[i].commissionRate < 0) {
            this.$message({
              showClose: true,
              message: "金额填写有误",
              type: "error"
            });
            this.dialogFormVisible = false;
            return;
          }
        }
        gcsobj.labelList.push(...this.gcsPlans);
        params.placeRuleResponses.push(gcsobj);
        console.log(gcsobj);
      }
      if (this.isSH) {
        let shobj = {};
        shobj.clientType = "JOINS_MERCHANT";
        shobj.merchantRate = this.form.merchantRate;
        shobj.labelList = [];
        if (shobj.miniRate < 0) {
          this.$message({
            showClose: true,
            message: "金额填写有误",
            type: "error"
          });
          this.dialogFormVisible = false;
          return;
        }
        for (let i = 0; i < this.shPlans.length; i++) {
          if (this.shPlans[i].commissionRate < 0) {
            this.$message({
              showClose: true,
              message: "金额填写有误",
              type: "error"
            });
            this.dialogFormVisible = false;
            return;
          }
        }
        shobj.labelList.push(...this.shPlans);
        params.placeRuleResponses.push(shobj);
        console.log(shobj);
      }
      console.log(this.form);
      console.log(this.zstPlans);
      console.log(this.gcsPlans);
      console.log(this.shPlans);
      console.log(params);
      console.log(this);
      this.$refs[formName].validate(valid => {
        if (valid) {
          console.log("success submit!!");
          editReleaseSale(params).then(res => {
            if (res.code == "200") {
              this.$message({
                showClose: true,
                message: "修改成功",
                type: "success"
              });
              this.dialogFormVisible = false;
              this.handleList();
            } else {
              this.$message({
                showClose: true,
                message: res.message,
                type: "error"
              });
              this.dialogFormVisible = false;
            }
          });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    }
  }
};
</script>

    <style lang="scss">
.table-container {
  padding: 8px 10px;
}

.demo-table-expand {
  font-size: 0;
}

.demo-table-expand label {
  width: 90px;
  color: #99a9bf;
}

.demo-table-expand .el-form-item {
  margin-right: 0;
  margin-bottom: 0;
  width: 50%;
}
</style>
